export enum EActionBarUpdateSource {
  DROPDOWN = 'dropdown',
  TOGGLE = 'toggle',
}
